import { Fragment } from 'react';
import { Marker } from 'react-map-gl/maplibre';

import { CustomMarker } from '../CustomMarker';
import { MarkerInfoWindow } from '../MarkerInfoWindow';

export const MarkerItem = ({
  realty,
  colors = {},
  activeMarker,
  setActiveMarker = () => {},
  handleActiveMarker = () => {},
  isSelected = false,
  renderPopupInline = true,
}) => {
  const { id, latitude, longitude } = realty;

  if (latitude == null || longitude == null) return null;

  return (
    <Fragment key={id}>
      <Marker
        longitude={Number(longitude)}
        latitude={Number(latitude)}
        anchor="bottom"
        onClick={e => {
          e.originalEvent.stopPropagation();
          handleActiveMarker(id);
        }}
      >
        <div
          style={{
            position: 'relative',
            cursor: 'pointer',
            width: '40px',
            height: '40px',
          }}
        >
          <CustomMarker
            colors={colors}
            isSelected={isSelected}
          />
        </div>
      </Marker>

      {renderPopupInline && activeMarker === id && (
        <MarkerInfoWindow
          realty={realty}
          setActiveMarker={setActiveMarker}
        />
      )}
    </Fragment>
  );
};
